var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconShop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "21.58 14.11 55.37 74.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m76.863 77.684-5.3203-38.5c-0.63672-4.6055-4.5547-8.1016-9.1797-8.2422v-3.7461c0-7.2148-5.8711-13.086-13.086-13.086s-13.086 5.8711-13.086 13.086v3.7461c-4.6328 0.12891-8.5625 3.6289-9.1992 8.2422l-5.3203 38.5c-0.37891 2.7383 0.44531 5.5039 2.2617 7.5859s4.4414 3.2773 7.207 3.2773h36.254c2.7656 0 5.3906-1.1953 7.207-3.2773 1.8164-2.0859 2.6406-4.8477 2.2617-7.5859zm-27.586-59.672c5.0625 0 9.1797 4.1172 9.1797 9.1797v3.7422h-18.359v-3.7422c0-5.0625 4.1172-9.1797 9.1797-9.1797z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShop);
export default __webpack_public_path__ + "static/media/icon-shop.f483a482c09209568e130ae91267f5a9.svg";
export { ForwardRef as ReactComponent };